/**
 * Edit timeline block.
 * @module components/manage/Blocks/Timeline/Edit
 */

import React from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { injectDNDSubblocks, SubblockEdit, Subblock } from 'volto-subblocks';
import ViewBlock from './ViewBlock';

/**
 * Edit timeline block class.
 * @class EditBlock
 * @extends Component
 */
class EditBlock extends SubblockEdit {
  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    if (__SERVER__) {
      return <div />;
    }

    return (
      <Subblock subblock={this} className="subblock-edit">
        <ViewBlock data={this.props.data} isEditMode={true} />
      </Subblock>
    );
  }
}

export default compose(injectIntl, injectDNDSubblocks)(EditBlock);
